import { commonRowAndCellClassRules } from '_legacy/components/grid/classRules/classRules';
import defaultSetFilterParams from '_legacy/components/grid/columnDefaults/defaultSetFilterParams';
import { LaycanToComparator } from '_legacy/components/grid/comparators/LaycanComparator';
import naturalSortComparator from '_legacy/components/grid/comparators/NaturalSortComparator';
import LaycanToFormatter from '_legacy/components/grid/formatters/LaycanToFormatter';

export const laycanToHeading = {
    colId: 'laycanTo',
    editable: false,
    headerName: 'L/C To',
    field: 'laycan',
    sortable: true,
    suppressMenu: true,
    valueFormatter: LaycanToFormatter,
    comparator: LaycanToComparator,
    hide: true,
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    filterParams: {
        ...defaultSetFilterParams,
        comparator: naturalSortComparator,
    },
    excelExportFormat: 'date',
    width: 80,
};
